import { ScrollArea } from '@base-ui/react/scroll-area';
import styled from 'styled-components';
import { breakpoints } from 'modules/v2/foundation/breakpoints';
import { pxToRem } from 'modules/v2/foundation/spacing';
import { themeGet } from 'modules/v2/foundation/theme';
export const StyledRoot = styled(ScrollArea.Root) `
  --scrollbar-size: ${pxToRem(4)};
  --scrollbar-background: ${themeGet('colors.background.100')};
  --scrollbar-background-hover: ${themeGet('colors.gray.100')};
  --scrollbar-thumb: hsl(0deg 0% 0% / 15%);
  --scrollbar-thumb-hover: hsl(0deg 0% 0% / 35%);

  width: 100%;
  height: 100%;
  max-width: inherit;
  max-height: inherit;
  border-radius: inherit;
  box-sizing: border-box;
  overflow: hidden;
`;
export const StyledThumb = styled(ScrollArea.Thumb) `
  flex: 1;
  background: var(--scrollbar-thumb);
  border-radius: var(--scrollbar-size);
  position: relative;

  /* increase target size for touch devices https://www.w3.org/WAI/WCAG21/Understanding/target-size.html */
  &::before {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
    height: 100%;
    min-width: ${pxToRem(44)};
    min-height: ${pxToRem(44)};
  }

  ${breakpoints.sm} {
    &::before {
      min-width: ${pxToRem(18)};
      min-height: ${pxToRem(18)};
    }
  }
`;
export const StyledScrollbar = styled(ScrollArea.Scrollbar) `
  z-index: 1;
  display: flex;
  user-select: none;
  touch-action: none;
  margin: ${pxToRem(4)};
  border-radius: ${themeGet('borderRadius.sm')};
  background: var(--scrollbar-background);
  transition: background 160ms ease-out;

  &:hover {
    background: var(--scrollbar-background-hover);

    ${StyledThumb} {
      background: var(--scrollbar-thumb-hover);
    }
  }

  &[data-orientation='vertical'] {
    width: var(--scrollbar-size);
  }

  &[data-orientation='horizontal'] {
    flex-direction: column;
    height: var(--scrollbar-size);
  }
`;
export const Viewport = styled(ScrollArea.Viewport) `
  width: 100%;
  height: 100%;
  max-width: inherit;
  max-height: inherit;
  border-radius: inherit;

  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }

  /* fix for this https://github.com/radix-ui/primitives/issues/926 */
  & > div {
    display: block !important;
    position: relative;
    height: 100%;
  }

  &:has(div[data-id='menu-header-sticky']) {
    & + ${StyledScrollbar} {
      margin-top: ${pxToRem(45)};
    }
  }
`;
export const StyledCorner = styled(ScrollArea.Corner) `
  background: var(--scrollbar-background-hover);
`;
